import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

export default class VisitAbility extends Ability {
  @service declare authz: AuthzService;

  /**
   * Can read visits, associated with a visitor profile
   *
   * this.abilities.can('read profile visits')
   */
  get canReadProfile(): boolean {
    return this.#canReadProfileLocationVisits || this.#canReadProfileGlobalVisits;
  }

  get #canReadProfileLocationVisits(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_VISITOR_PROFILE_READ_VISITS);
  }

  get #canReadProfileGlobalVisits(): boolean {
    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_VISITOR_PROFILE_READ_VISITS_GLOBAL);
  }
}
